import * as React from 'react';
import styled from 'styled-components';
import { Button } from '@mui/material';
import { brandingColourHeavy, tabletPortraitMinWidth, whiteColour } from '../../../cssConstants';

const PublicFormButtons = ({
	onBackButtonClick,
	onContinueButtonClick,
	backButtonText,
	continueButtonText,
	disabled = false
}: Props) => {
	return (
		<StyledFormButtons>
			{onBackButtonClick && (
				<StyledCustomButton type="button" variant="contained" onClick={onBackButtonClick}>
					{backButtonText ?? 'Back'}
				</StyledCustomButton>
			)}
			<StyledCustomButton
				type="submit"
				variant="contained"
				onClick={onContinueButtonClick}
				disabled={disabled}
				$isSubmitButton
			>
				{continueButtonText ?? 'Continue'}
			</StyledCustomButton>
		</StyledFormButtons>
	);
};

export default PublicFormButtons;

interface Props {
	onBackButtonClick?: () => void;
	onContinueButtonClick?: () => void;
	backButtonText?: string;
	continueButtonText?: string;
	disabled?: boolean;
}

const StyledFormButtons = styled.section`
	display: flex;
	flex-direction: column-reverse;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
	text-align: center;

	/* If this section is a child of a form, adjust the margin-top */
	form & {
		margin-top: 10px;
	}

	@media (min-width: ${tabletPortraitMinWidth}) {
		display: block;
	}
`;

const StyledCustomButton = styled(Button)<{ $isSubmitButton: boolean }>`
	display: inline-flex;
	border-radius: 30px;
	text-transform: none;
	font-weight: 400px;
	margin: 10px;
	line-height: 22px;
	background-color: ${({ $isSubmitButton }) => ($isSubmitButton ? brandingColourHeavy : whiteColour)};
	color: ${({ $isSubmitButton }) => ($isSubmitButton ? whiteColour : brandingColourHeavy)};
	font-size: 16px;
	height: 50px;
	width: 200px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 18px;
		height: 60px;
		width: 230px;
	}

	&:hover {
		opacity: 1;
		background-color: ${({ $isSubmitButton }) => ($isSubmitButton ? brandingColourHeavy : whiteColour)};
	}
`;
